// Polyfills for browser compatibility
// Provide a Node-like global object expected by some dependencies (buffer, stream, etc.)
if (typeof global === "undefined") {
    window.global = window;
}
